<template>
  <div>
    <a-table
      :columns="itemColumns"
      :data-source="items"
      :pagination="false"
      :scroll="{ y: 200 }"
    />

    <a-table
      :columns="nodeColumns"
      :data-source="nodes"
      :pagination="false"
      :scroll="{ y: 200 }"
      style="margin-top: 15px;"
    />
  </div>
</template>

<script>
import { findServiceOrderDirectorInfo } from '@/api/order'

export default {
  name: 'DirectorInfo',
  props: {
    serviceOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      items: [],
      nodes: []
    }
  },
  computed: {
    itemColumns() {
      return [
        {
          title: '理事项',
          dataIndex: 'name'
        },
        {
          title: '负责人',
          dataIndex: 'director'
        }
      ]
    },
    nodeColumns() {
      return [
        {
          title: '服务节点',
          dataIndex: 'name',
          width: 100
        },
        {
          title: '日期',
          dataIndex: 'date'
        },
        {
          title: '农历',
          dataIndex: 'lunar',
          width: 150
        },
        {
          title: '星期',
          dataIndex: 'week',
          width: 150
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 150
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findServiceOrderDirectorInfo(this.serviceOrderId).then(res => {
        if (res.code === 0) {
          this.data = res.data
          this.items = res.data.director_items
          this.nodes = res.data.nodes
        }
      })
    }
  }
}
</script>

